/* eslint-disable max-len */
export default {
  security: [
    {
      id: 102,
      title: "S01E02 | Amber Ashlynn",
      description: "...",
      time: "3 mins",
      thumbnail:
        "https://posture-ninjio.s3-us-west-2.amazonaws.com/season_1/Episode+2+Amber+Ashlynn/s01e02-thumbnail.png",
      video:
        "https://posture-ninjio.s3-us-west-2.amazonaws.com/season_1/Episode+2+Amber+Ashlynn/1-NINJIO-S1E2-NoSubs-NoQuiz.mp4"
    },
    {
      id: 206,
      title: "S02E06 | My Password is Password",
      description: "...",
      time: "5 mins",
      thumbnail:
        "https://posture-ninjio.s3-us-west-2.amazonaws.com/season_2/Episode+6+My+Password+is+_Password_/s02e06-thumbnail.png",
      video:
        "https://s3-us-west-2.amazonaws.com/ninjio/Episode+6+My+Password+is+'Password'/story_content/video_6WQPwx9QDKG_18_56_960x554.mp4"
    },
    {
      id: 301,
      title: "S03E01 | Phishing the Stream",
      description: "...",
      time: "5 mins",
      thumbnail:
        "https://s3-us-west-2.amazonaws.com/ninjio/Episode+1+Phishing+the+Stream/phishing.jpg",
      video:
        "https://s3-us-west-2.amazonaws.com/ninjio/Episode+1+Phishing+the+Stream/story_content/video_62pN0GwqyFL_18_56_1202x676.mp4"
    },
    {
      id: 306,
      title: "S03E06 | Ransomware is Everywhere!",
      description: "...",
      time: "4 mins.",
      thumbnail:
        "https://s3-us-west-2.amazonaws.com/ninjio/Episode+6+Ransomware+is+Everywhere/ransom.jpg",
      video:
        "https://s3-us-west-2.amazonaws.com/ninjio/Episode+6+Ransomware+is+Everywhere/story_content/video_6O5ouDIwF40_18_56_1138x640.mp4"
    },
    {
      id: 406,
      title: "S04E06 | Vacation Devastation",
      description: "...",
      time: "4 mins.",
      thumbnail:
        "https://posture-ninjio.s3-us-west-2.amazonaws.com/season_4/Episode+6+-+Vacation+Devastation/NINJIO-S4E6-Vacation+Devastation+-+Social+Media+Security.jpg",
      video:
        "https://posture-ninjio.s3-us-west-2.amazonaws.com/season_4/Episode+6+-+Vacation+Devastation/NINJIO-S4E6-Vacation+Devastation+-+Social+Media+Security.mp4"
    },
    {
      id: 409,
      title: "S04E09 | USB Nation",
      description: "...",
      time: "4 mins.",
      thumbnail:
        "https://posture-ninjio.s3-us-west-2.amazonaws.com/season_4/Episode+9+-+USB+Nation/NINJIO-S4E9-USB+Nation+-+USB+Security.jpg",
      video:
        "https://posture-ninjio.s3-us-west-2.amazonaws.com/season_4/Episode+9+-+USB+Nation/NINJIO-S4E9-USB+Nation+-+USB+Security.mp4"
    }
  ],
  hipaa: [    
    {
    id: 502,
    title: "Episode 1 | An Avoidable Accident",
    description: "...",
    time: "5 mins.",
    thumbnail:
      "https://posture-ninjio.s3-us-west-2.amazonaws.com/HIPAA/Episode+1/An+Avoidable+Accident.png",
    video:
      "https://posture-ninjio.s3-us-west-2.amazonaws.com/HIPAA/Episode+1/Episode+1+An+Avoidable+Accident.mp4"
  },
  {
    id: 504,
    title: "Episode 2 | Placing the Blame",
    description: "...",
    time: "4 mins.",
    thumbnail:
      "https://posture-ninjio.s3-us-west-2.amazonaws.com/HIPAA/Episode+2/Placing+the+Blame.png",
    video:
      "https://posture-ninjio.s3-us-west-2.amazonaws.com/HIPAA/Episode+2/Episode+2+Placing+the+Blame.mp4"
  },
  {
    id: 510,
    title: "Episode 3 | Time for a Change",
    description: "...",
    time: "4 mins.",
    thumbnail:
      "https://posture-ninjio.s3-us-west-2.amazonaws.com/HIPAA/Episode+3/Time+for+a+Change.png",
    video:
      "https://posture-ninjio.s3-us-west-2.amazonaws.com/HIPAA/Episode+3/Episode+3+Time+for+a+Change.mp4"
  },
  ],
  currentMonthsVideo: [
    {
      id: 607,
      title: "S06E07 | NINJO",
      description: "...",
      time: "5 mins.",
      thumbnail:
        "https://posture-ninjio.s3.us-west-2.amazonaws.com/season_6/episode_7/607_lockscreen_blank.jpeg",
      video:
        "https://posture-ninjio.s3.us-west-2.amazonaws.com/season_6/episode_7/3-NINJIO-S6E07-Subs-NoQuiz.mp4"
    }
  ],
  pci: [
    {
      id: "101",
      title: "Episode 1 | The Disinterested CEO",
      description: "",
      time: "4 mins.",
      thumbnail: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_1/PCI+Episode+1+Thumbnail.png",
      video: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_1/3-PCI_EP1_Final_SubtitleNoQuiz.mp4"
    },
    {
      id: "102",
      title: "Episode 2 | Just Scraping By",
      description: "",
      time: "4 mins.",
      thumbnail: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_2/PCI+Episode+2+Thumbnail.png",
      video: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_2/3-PCI_EP2_Final_SubtitleNoQuiz.mp4"
    },
    {
      id: "103",
      title: "Episode 3 | Life's A Breach",
      description: "",
      time: "4 mins.",
      thumbnail: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_3/PCI+Episode+3+Thumbnail.png",
      video: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_3/3-PCI_EP3_Final_SubtitleNoQuiz.mp4"
    },
    {
      id: "104",
      title: "Episode 4 | Payment Card Predicament",
      description: "",
      time: "6 mins.",
      thumbnail: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_4/PCI+Episode+4+Thumbnail.png",
      video: "https://posture-ninjio.s3-us-west-2.amazonaws.com/PCI/episode_4/3_PCI_4_NoQuiz_Sub.mp4"
    }
  ]
};




// WEBPACK FOOTER //
// ./src/components/training/components/catalog_list.js